import {Component, OnDestroy, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {BehaviorSubject, Subject, filter, map, takeUntil} from 'rxjs';
import {Constrain} from 'src/app/models/Contstrain';
import {Venue} from 'src/app/models/Venue';
import {AuthFacade} from 'src/app/store/auth-state/+state/auth.facade';
import {ManagerFacade} from 'src/app/store/manager/+state/manager.facade';

@Component({
	selector: 'app-trade-groups',
	templateUrl: './trade-groups.page.html',
	styleUrls: ['./trade-groups.page.scss']
})
export class TradeGroupsPage implements OnInit, OnDestroy {
	public venue$ = new BehaviorSubject<Venue | null>(null);
	private readonly onDestroy$ = new Subject<void>();
	public tradeGroups$ = this.venue$.pipe(
		map(venue => {
			return venue?.constrains ?? [];
		})
	);
	constructor(
		private managerFacade: ManagerFacade,
		public translate: TranslateService,
		private authFacade: AuthFacade
	) {}

	ngOnInit() {
		this.authFacade.userData$
			.pipe(
				filter(userValue => !!userValue),
				map(userData => {
					return userData?.venues[0] ?? null;
				}),
				takeUntil(this.onDestroy$)
			)
			.subscribe(venueId => {
				if (venueId) {
					this.loadDataByUser(venueId);
				}
			});
		this.managerFacade.venue$
			.pipe(takeUntil(this.onDestroy$))
			.subscribe(result => {
				this.venue$.next(result);
			});
	}
	ngOnDestroy(): void {
		this.onDestroy$.next();
	}
	private loadDataByUser(venueId: string) {
		this.managerFacade.loadVenueData({venueId});
	}
	public changeItemActive(event: boolean, item: Constrain) {
		console.log(event, item);
		this.managerFacade.updateTradeGroups({
			constrainId: item._id,
			venueId: this.venue$.getValue()?._id ?? '',
			active: event
		});
	}
}
